import axios from "axios";

export interface SystemListItem {
  system_id: string;
  name: string;
  status: string;
  device_count: number;
  sensor_count: number;
}

interface SystemListResponse {
  systems?: SystemListItem[];
}

const SystemService = {
  listSystems: async (orgId: string): Promise<SystemListItem[]> => {
    const response = await axios.get<SystemListResponse>(`/api/proxy/systems/list?org_id=${orgId}`);
    return response.data.systems || [];
  },

  getSystem: async (orgId: string, systemId: string) => {
    const response = await axios.get(`/api/proxy/systems/${orgId}/${systemId}`);
    return response.data;
  },

  createSystem: async (orgId: string, systemName: string, category: string) => {
    const response = await axios.post(`/api/proxy/systems/${orgId}?orgId=${orgId}`, {
      system_name: systemName,
      category_id: category,
    });
    return response.data;
  },

  deleteSystem: async (orgId: string, systemId: string) => {
    const response = await axios.delete(`/api/proxy/systems/${orgId}/${systemId}`);
    return response.data;
  },

  getSystemStatus: async (orgId: string, systemId: string) => {
    const response = await axios.get(`/api/proxy/systems/${orgId}/${systemId}/status`);
    return response.data;
  },
};

export default SystemService;
